import _form from './form';
import _wizardForm from './wizard-form';
/**
 * Creates a form generator function that uses the passed in UI-Kit to render fields.
 * @param {object} UIKit - A map of field types to react components.
 * @returns {{ form: function, wizardForm: function }} - An object with a form generator function and a wizard form generator function.
 */

export default function createReduxForm(UIKit) {
  return {
    form: function form() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _form.apply(undefined, [UIKit].concat(args));
    },
    wizardForm: function wizardForm() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _wizardForm.apply(undefined, [UIKit].concat(args));
    }
  };
}